import axios from 'axios'
import library from '../../../utils/Library'

export const getOrganizationCommercialUserTypeCorpEntities = async () => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('organization') +
    '/getOrganizationCommercialUserTypeCorpEntities'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
